/*
Copyright 2020 Google LLC

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
export default class NameHat {

  constructor() {
    this.names = [];
  }

  setNames(names) {
    this.names = names;
  }

  getNames() {
    return this.names;
  }

  empty() {
    this.names = [];
  }

  numberOfNames() {
    return this.names.length;
  }

  pullRandomName() {
    const name = this.getRandomName();
    const indexOfName = this.names.indexOf(name);
    if (indexOfName > -1) {
      this.names.splice(indexOfName, 1);
    }
    return name;
  }

  addName(name) {
    this.names.push(name);
  }

  getRandomName() {
    return this.names[Math.floor(Math.random()*this.names.length)];
  }

}
